import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
/**
 * Delete Process Chain Response Schema
 * DELETE /api/v2/process-chains/:id
 */ export const DeleteProcessChainResponseSchema = z.object({
    success: z.boolean()
});
export const DeleteProcessChainErrorSchema = BaseErrorSchema;

//# sourceMappingURL=delete-process-chain.schema.js.map